/**
 * Извлекает ID заказа из URL вида /booking/{orderId}/...
 * @param pathname - путь из location.pathname
 * @returns orderId или null, если не найден
 */
export const extractOrderIdFromPathname = (pathname: string): string | null => {
	const match = pathname.match(/\/booking\/(\d+)\//);

	return match?.[1] ?? null;
};
